import Vue from "vue";
import AppDropDownList from "@/components/Inputs/AppDropDownList.vue";
export default Vue.extend({
    components: {
        "app-dropdownlist": AppDropDownList
    },
    props: {
        id: {
            type: String,
            required: true
        },
        enabled: {
            type: Boolean,
            required: false,
            default: true
        },
        placeholder: {
            type: String,
            required: false
        },
        value: {
            type: [String, Boolean, Number],
            required: false
        },
        cssClass: {
            type: String,
            required: false,
            default: ""
        }
    },
    data() {
        return {
            source: [
                { text: this.$t("shared.yes"), value: 1 },
                { text: this.$t("shared.no"), value: 0 },
                { text: this.$t("shared.all"), value: -1 },
            ],
            fields: { text: "text", value: "value" }
        };
    },
    methods: {
        emitValue(value) {
            this.$emit("input", value);
        }
    }
});
